import React from "react";
import Loadable from "react-loadable";
import { Loading } from "components";

const MyLoadingComponent = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return <Loading />;
  }
  // Handle the error state
  else if (error) {
    return (
      <div>متاسفانه در نمایش این صفحه مشکلی بوجود آمده است .منتظر بمانید.</div>
    );
  } else {
    return null;
  }
};

export default [
  [
    {
      component: Loadable({
        loader: () => import("./views/SignIn"),
        loading: MyLoadingComponent
      }),
      link: "/",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/Reset"),
        loading: MyLoadingComponent
      }),
      link: "/reset",
      public: true
    },
    {
      component: Loadable({
        loader: () => import("./views/Verify"),
        loading: MyLoadingComponent
      }),
      link: "/reset/verify/:token",
      public: true
    }
  ],
  [
    {
      component: Loadable({
        loader: () => import("./views/Account"),
        loading: MyLoadingComponent
      }),
      link: "/maininformation",
      public: false,
      name: "033"
    },
    {
      component: Loadable({
        loader: () => import("./views/MyBeneficyProfile"),
        loading: MyLoadingComponent
      }),
      link: "/mybeneficyprofile",
      public: false,
      name: "037"
    },
    {
      component: Loadable({
        loader: () => import("./views/AddMember"),
        loading: MyLoadingComponent
      }),
      link: "/addmember",
      public: false,
      name: "042"
    },
    {
      component: Loadable({
        loader: () => import("./views/DownlineMember"),
        loading: MyLoadingComponent
      }),
      link: "/downlinemember",
      public: false,
      name: "044"
    },
    {
      component: Loadable({
        loader: () => import("./views/DirectReferall"),
        loading: MyLoadingComponent
      }),
      link: "/directreferall",
      public: false,
      name: "046"
    },
    {
      component: Loadable({
        loader: () => import("./views/StartReferalls"),
        loading: MyLoadingComponent
      }),
      link: "/startupreferall",
      public: false,
      name: "178"
    },
    {
      component: Loadable({
        loader: () => import("./views/NetworkExplorer"),
        loading: MyLoadingComponent
      }),
      link: "/networkexplorer",
      public: false,
      name: "043"
    },
    {
      component: Loadable({
        loader: () => import("./views/MyRepresentativePosition"),
        loading: MyLoadingComponent
      }),
      link: "/mymepresentativeposition",
      public: false,
      name: "017"
    },
    {
      component: Loadable({
        loader: () => import("./views/Upgrade"),
        loading: MyLoadingComponent
      }),
      link: "/Upgrade",
      public: false,
      name: "492"
    },
    {
      component: Loadable({
        loader: () => import("./views/PaymentMethods"),
        loading: MyLoadingComponent
      }),
      link: "/PaymentMethods",
      public: false,
      name: "035"
    },
    {
      component: Loadable({
        loader: () => import("./views/KYC"),
        loading: MyLoadingComponent
      }),
      link: "/kyc",
      public: false,
      name: "036"
    },
    {
      component: Loadable({
        loader: () => import("./views/Products"),
        loading: MyLoadingComponent
      }),
      link: "/products",
      public: false,
      name: "132"
    },
    {
      component: Loadable({
        loader: () => import("./views/security"),
        loading: MyLoadingComponent
      }),
      link: "/security",
      public: false,
      name: "038"
    },
    {
      component: Loadable({
        loader: () => import("./views/PurchaseHistory"),
        loading: MyLoadingComponent
      }),
      link: "/PurchaseHistory",
      public: false,
      name: "051"
    },
    {
      component: Loadable({
        loader: () => import("./views/LeadCapturing"),
        loading: MyLoadingComponent
      }),
      link: "/LeadCapturing",
      public: false,
      name: "047"
    },
    {
      component: Loadable({
        loader: () => import("./views/NoPage"),
        loading: MyLoadingComponent
      }),
      link: "/nopage",
      public: true,
      name: "119"
    },
    {
      component: Loadable({
        loader: () => import("./views/GenealogyTree"),
        loading: MyLoadingComponent
      }),
      link: "/genealogy",
      public: false,
      name: "045"
    },
    {
      component: Loadable({
        loader: () => import("./views/NetworkBonus"),
        loading: MyLoadingComponent
      }),
      link: "/networkbonus",
      public: false,
      name: "055"
    },
    {
      component: Loadable({
        loader: () => import("./views/DirectSaleBonus"),
        loading: MyLoadingComponent
      }),
      link: "/directsalebonus",
      public: false,
      name: "056"
    },
    {
      component: Loadable({
        loader: () => import("./views/RankBonus"),
        loading: MyLoadingComponent
      }),
      link: "/rankbonus",
      public: false,
      name: "057"
    },
    {
      component: Loadable({
        loader: () => import("./views/FlashOut"),
        loading: MyLoadingComponent
      }),
      link: "/flashout",
      public: false,
      name: "058"
    },
    {
      component: Loadable({
        loader: () => import("./views/Vouchers"),
        loading: MyLoadingComponent
      }),
      link: "/vouchers",
      public: false,
      name: "059"
    },
    {
      component: Loadable({
        loader: () => import("./views/Compliance/PrivacyPolicy"),
        loading: MyLoadingComponent
      }),
      link: "/privacyPolicy",
      public: false,
      name: "095"
    },
    {
      component: Loadable({
        loader: () => import("./views/Compliance/MyContract"),
        loading: MyLoadingComponent
      }),
      link: "/MyContract",
      public: false,
      name: "091"
    },
    {
      component: Loadable({
        loader: () => import("./views/Compliance/Audit"),
        loading: MyLoadingComponent
      }),
      link: "/audit",
      public: false,
      name: "092"
    },
    {
      component: Loadable({
        loader: () => import("./views/Compliance/LegalDocument"),
        loading: MyLoadingComponent
      }),
      link: "/legalDocuments",
      public: false,
      name: "093"
    },
    {
      component: Loadable({
        loader: () => import("./views/Compliance/AccessRequestFrom"),
        loading: MyLoadingComponent
      }),
      link: "/accessRequestFrom",
      public: false,
      name: "096"
    },
    {
      component: Loadable({
        loader: () => import("./views/Compliance/TermsAndCondition"),
        loading: MyLoadingComponent
      }),
      link: "/termsAndCondition",
      public: false,
      name: "240"
    },
    {
      component: Loadable({
        loader: () => import("./views/Compliance/ConsentWithdrawal"),
        loading: MyLoadingComponent
      }),
      link: "/ConsentWithdrawal",
      public: false,
      name: "097"
    },
    {
      component: Loadable({
        loader: () => import("./views/ProductAndBusinessPresentations"),
        loading: MyLoadingComponent
      }),
      link: "/productAndBusinessPresentations",
      public: false,
      name: "089"
    },
    {
      component: Loadable({
        loader: () => import("./views/BrandingMaterials"),
        loading: MyLoadingComponent
      }),
      link: "/brandingMaterials",
      public: false,
      name: "087"
    },
    {
      component: Loadable({
        loader: () => import("./views/PromotionTools"),
        loading: MyLoadingComponent
      }),
      link: "/PromotionTools",
      public: false,
      name: "081"
    },
    {
      component: Loadable({
        loader: () =>
          import("./views/InformationAndEducationCenter/EducationPlatform"),
        loading: MyLoadingComponent
      }),
      link: "/informationAndEducationCenter/educationPlatform",
      public: false,
      name: "098"
    },
    {
      component: Loadable({
        loader: () => import("./views/Events"),
        loading: MyLoadingComponent
      }),
      link: "/informationAndEducationCenter/Events",
      public: false,
      name: "263"
    },
    {
      component: Loadable({
        loader: () => import("./views/Messages/Messages"),
        loading: MyLoadingComponent
      }),
      link: "/Messages",
      public: false,
      name: "106"
    },
    {
      component: Loadable({
        loader: () => import("./views/Chat"),
        loading: MyLoadingComponent
      }),
      link: "/chat",
      public: false,
      name: "108"
    },
    {
      component: Loadable({
        loader: () => import("./views/WhistleBlowerReport"),
        loading: MyLoadingComponent
      }),
      link: "/WhistleBlowerReport",
      public: false,
      name: "111"
    },
    {
      component: Loadable({
        loader: () => import("./views/UnSubscribe"),
        loading: MyLoadingComponent
      }),
      link: "/UnSubscribe",
      public: false,
      name: "267"
    },
    {
      component: Loadable({
        loader: () => import("./views/Dashboard"),
        loading: MyLoadingComponent
      }),
      link: "/dashboard",
      public: false,
      name: "016"
    },
    {
      component: Loadable({
        loader: () => import("./views/SignUp"),
        loading: MyLoadingComponent
      }),
      link: "/sign-up",
      public: true
    },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/SamplesList"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/samples-list",
    //   public: false
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/NewSample"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/new-sample",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/Receive"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/receive",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/Pelleting"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/pelleting",
    //   public: false
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/Procedure"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/procedure",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/Results"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/results",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/NewUser"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/new-user",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/UserList"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/users",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/Typography"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/typography",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/Icons"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/icons",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/Account"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/account",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/Settings"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/settings",
    //   public: true
    // },
    // {
    //   component: Loadable({
    //     loader: () => import("./views/UnderDevelopment"),
    //     loading: MyLoadingComponent
    //   }),
    //   link: "/under-development",
    //   public: true
    // },
    {
      component: Loadable({
        loader: () => import("./views/NotFound"),
        loading: MyLoadingComponent
      }),
      link: "/not-found",
      public: true,
      name: "Not Found"
    }
  ]
];
